import { render } from "./vsurplusset.vue?vue&type=template&id=099eb7a6&scoped=true"
import script from "./vsurplusset.vue?vue&type=script&lang=js"
export * from "./vsurplusset.vue?vue&type=script&lang=js"

import "./vsurplusset.vue?vue&type=style&index=0&id=099eb7a6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099eb7a6"]])

export default __exports__